import { render, staticRenderFns } from "./notificationList.vue?vue&type=template&id=70146dba&scoped=true"
import script from "./notificationList.vue?vue&type=script&lang=js"
export * from "./notificationList.vue?vue&type=script&lang=js"
import style0 from "./notificationList.vue?vue&type=style&index=0&id=70146dba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70146dba",
  null
  
)

export default component.exports